export const EMPLOYER_PERMISSIONS = {
  DASHBOARD: 'dashboard',
  REPORTS: 'reports',
  JOBS: 'jobs',
  CANDIDATES: 'candidates',
  INTERVIEWS: 'interviews',
  OFFERS: 'offers',
  ASSESSMENTS: 'assessments',
  CONFIGURATION: 'configuration',
  PROFILE: 'profile',
  ROLES: 'roles',
  USERS: 'users'
};

export const permissionLabels = {
  dashboard: 'Dashboard',
  reports: 'Reports',
  jobs: 'Jobs',
  candidates: 'Candidates',
  interviews: 'Interviews',
  offers: 'Offers',
  assessments: 'Assessments',
  configuration: 'Configuration',
  profile: 'Profile',
  roles: 'Roles',
  users: 'Users'
};

const permissionOrder = [
  EMPLOYER_PERMISSIONS.DASHBOARD,
  EMPLOYER_PERMISSIONS.REPORTS,
  EMPLOYER_PERMISSIONS.JOBS,
  EMPLOYER_PERMISSIONS.CANDIDATES,
  EMPLOYER_PERMISSIONS.INTERVIEWS,
  EMPLOYER_PERMISSIONS.OFFERS,
  EMPLOYER_PERMISSIONS.ASSESSMENTS,
  EMPLOYER_PERMISSIONS.CONFIGURATION,
  EMPLOYER_PERMISSIONS.PROFILE,
  EMPLOYER_PERMISSIONS.ROLES,
  EMPLOYER_PERMISSIONS.USERS
];

export const getPermissionLabel = (permission) => permissionLabels[permission] || permission;

export const hasPermission = (user, permission) => {
  if (!permission) return true;
  if (user?.isEmployerSuperAdmin) return true;
  return Array.isArray(user?.permissions) && user.permissions.includes(permission);
};

export const hasAnyPermission = (user, permissions = []) => permissions.some((permission) => hasPermission(user, permission));

export const isEmployerSuperAdmin = (user) => Boolean(user?.isEmployerSuperAdmin);

export const getPermissionsForDisplay = (permissions = []) => (
  permissionOrder.filter((permission) => permissions.includes(permission))
);

export const routePermissionMap = [
  { prefix: '/dashboard', permission: EMPLOYER_PERMISSIONS.DASHBOARD },
  { prefix: '/reports', permission: EMPLOYER_PERMISSIONS.REPORTS },
  { prefix: '/jobs', permission: EMPLOYER_PERMISSIONS.JOBS },
  { prefix: '/candidates', permission: EMPLOYER_PERMISSIONS.CANDIDATES },
  { prefix: '/interviews', permission: EMPLOYER_PERMISSIONS.INTERVIEWS },
  { prefix: '/offers', permission: EMPLOYER_PERMISSIONS.OFFERS },
  { prefix: '/assessments', permission: EMPLOYER_PERMISSIONS.ASSESSMENTS },
  { prefix: '/config', permission: EMPLOYER_PERMISSIONS.CONFIGURATION },
  { prefix: '/profile', permission: EMPLOYER_PERMISSIONS.PROFILE },
  { prefix: '/roles', permission: EMPLOYER_PERMISSIONS.ROLES, superAdminOnly: true },
  { prefix: '/users', permission: EMPLOYER_PERMISSIONS.USERS, superAdminOnly: true }
];

export const getRouteRequirement = (pathname = '') => (
  routePermissionMap.find((route) => pathname === route.prefix || pathname.startsWith(`${route.prefix}/`))
);

export const canAccessPath = (user, pathname = '') => {
  const requirement = getRouteRequirement(pathname);
  if (!requirement) return true;
  if (requirement.superAdminOnly) return isEmployerSuperAdmin(user);
  return hasPermission(user, requirement.permission);
};

export const getDefaultAllowedPath = (user) => {
  const route = routePermissionMap.find((item) => !item.superAdminOnly && hasPermission(user, item.permission));
  return route?.prefix || '/profile';
};
